export default {"src":"/_next/static/media/tucan.logo.dark.b3641df6.svg","height":40,"width":107,"blurWidth":0,"blurHeight":0};